var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgChevronBig = function SvgChevronBig(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m10 11.81 5.792-5.792 1.178 1.179-6.97 6.97-6.97-6.97 1.178-1.179L10 11.81Z",
    fill: "#9A99B2"
  })));
};
export { SvgChevronBig as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEwIDExLjgxTDE1Ljc5MTcgNi4wMTgzN0wxNi45NyA3LjE5NjdMMTAgMTQuMTY2N0wzLjAzMDAzIDcuMTk2N0w0LjIwODM2IDYuMDE4MzdMMTAgMTEuODFaIiBmaWxsPSIjOUE5OUIyIi8+Cjwvc3ZnPgo=";